export enum ViewTypes {
    CBL = 0,
    EXPORTJOB = 1,
    EQUIPMENT = 3
}